module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/slider/image12-c7ee99b819cb404f4eca5c09320f4463.jpg";